import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';

import { VerificationService } from '@sheerid/jslib';
import { redirect } from '../../lib/utils/browser';
import { VerificationResult } from '../../lib/types/runtimeTypes';
import { getRedirectUrl } from '../../lib/utils/stepComponentHelpers';

interface StepSuccessProps {
    verificationService: VerificationService;
}

const StepSuccess = ({ verificationService }: StepSuccessProps) => {
    const redirectUrl = getRedirectUrl(verificationService, VerificationResult.SUCCESS);

    React.useEffect(() => {
        // @ts-expect-error - gtag is defined on the window object in index.html
        window.gtag('event', 'page_view', {
            page_title: 'Thanks for verifying your student status',
            page_location: `${window.location.pathname}${window.location.search}`,
            page_path: 'review_success',
        });
    }, []);

    return (
        <div id="sid-step-success" className="sid-l-container">
            <div className="sid-header sid-l-horz-center sid-l-space-top-md">
                <div className="sid-header__title sid-l-horz-center sid-l-space-top-md">
                    <FormattedHTMLMessage id="step.success.title" defaultMessage="Success! You've been verified." />
                </div>
                <div className="sid-header__subtitle">
                    <FormattedHTMLMessage id="step.success.subtitle" defaultMessage={
                        `Here is your personal coupon code.
                        It is unique to you and can only be used once.`
                    } />
                </div>
            </div>

            <div className="sid-submit sid-l-space-top-md">
                <button
                    onClick={() => redirect(redirectUrl)}
                    className="sid-btn sid-btn--dark"
                >
                    <FormattedHTMLMessage id="step.success.redirectButtonText" defaultMessage="Use code now" />
                </button>
            </div>
        </div>
    );
};


export const StepSuccessComponent = StepSuccess;

